import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";

let o = {
  Name: "",
  BillingAddress: {
    AlternatePhone: "",
    City: "",
    Street1: "",
    Street2: "",
    State: "",
    ZIP: "",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
    Country: "USA",
    County: "",
  },
  DirectTrust: false,
  IDProofingRequired: false,
  RegistrationAPIActive: false,
  TrustedAgentAgreement: false,
  IsDirectorySharing: false,
  AllowInvites: false,
  InvitationAdminDefault: false,
  InvitationUserDefault: false,
  ApplicationAccessENS: false,
  DirectRoute: false,
  EmailForwardingType: 0,
  ApplicationAccessForms: false,
  ApplicationAccessDME: false,
  ApplicationAccessPriorAuthorization: false,
  ApplicationAccessSESConnect: false,
  ApplicationAccessXDR: false,
  CreatedBy: "",
  BaseDomainId: 0,
  SystemCreated: 1,
  TwoFactorAuth: false,
  AllowTwoFactor: false,
};

function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

const RegFormCustomer = () => {
  const navigate = useNavigate();
  const {
    setCustomerObj,
    userToken,
    userRole,
    setCustomerFlag,
    SetSharedObject,
  } = useUserStore((state) => ({
    setCustomerObj: state.setCustomerObj,
    userToken: state.userToken,
    userRole: state.userRole,
    setCustomerFlag: state.setCustomerFlag,
    SetSharedObject: state.SetSharedObject,
  }));

  const [answers, setAnswers] = useState(o);
  const [processing, SetProcessing] = useState(false);
  const setAnswer = async (questionId, answer, chck) => {
    if (questionId === "EmailForwardingTypeBox") {
      if (answer) {
        answers.EmailForwardingType = 2;
      } else {
        answers.EmailForwardingType = 0;
      }
    } else if (questionId === "DirectRoute") {
      if (answer) {
        answers.EmailForwardingType = 1;
      } else {
        answers.EmailForwardingType = 0;
      }
    }
    if (chck) {
      let obj = { ...answers };
      let add = answers.BillingAddress;
      add[questionId] = answer;
      obj.BillingAddress = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };
  const [domainObj, SetDomainObj] = useState([]);
  useEffect(() => {
    const getDomains = async () => {
      SetProcessing(true);
      SetErrMsg(false);
      let call = "/customers/GetDomains";
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetProcessing(false);
        SetDomainObj(res.data.data);
      } else if (res.status === "SERVERERROR") {
        let str =
          "A system error occurred searching for your results. Please contact support for further assistance.";
        SetMsg(str);
        SetErrMsg(true);
        SetProcessing(false);
      }
    };
    getDomains();
    ResetData();
    return () => {
      ResetData();
    };
  }, []);
  const ResetData = async () => {
    let obj = {
      AlternatePhone: "",
      City: "",
      Street1: "",
      Street2: "",
      State: "",
      ZIP: "",
      Phone: "",
      PhoneExt: "",
      Fax: "",
      FaxExt: "",
      Country: "USA",
      County: "",
    };
    await setAnswers({ ...o, BillingAddress: obj });
    };


    const validatePhoneNumber = (str) => {
        let flag = /[^0-9.]/.test(str);
        if (str.length < 10) {
            flag = true;
        }
    };
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false); //
  const [errMsg, SetErrMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const updateUser = async () => {
    SetErrMsg(false);
    SetFrmSubmFlag(true);
    if (!answers.Name) {
      document.getElementById("Name").scrollIntoView();
      document.getElementById("Name").focus();
      return;
    } else if (!answers.BaseDomainId) {
      document.getElementById("BaseDomainId").scrollIntoView();
      document.getElementById("BaseDomainId").focus();
      return;
    } else if (!answers.BillingAddress.Street1) {
      document.getElementById("Street1").scrollIntoView();
      document.getElementById("Street1").focus();
      return;
    } else if (!answers.BillingAddress.City) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (!answers.BillingAddress.State) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (!answers.BillingAddress.ZIP) {
      document.getElementById("ZIP").scrollIntoView();
      document.getElementById("ZIP").focus();
      return;
    } else if (!answers.BillingAddress.Phone) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }

    answers.CreatedBy = userRole;
    // let custExists = "/customers/CustomerExist?Name=" + answers.Name;
    // const respone = await CallAPI(custExists, false, "post", userToken);
    // await SetSharedObject("ResponseCode", res.code);
    // if (respone.status === "SUCCESS") {
    //   if (respone.data.data) {
    //     SetMsg("Customer Name Already Exists.");
    //     SetErrMsg(true);
    //     return;
    //   }
    // } else if (res.status === "SERVERERROR") {
    //   let str =
    //     "A system error occurred searching for your results. Please contact support for further assistance.";
    //   SetMsg(str);
    //   SetErrMsg(true);
    //   SetProcessing(false);
    // }
    if (
      answers.RegistrationAPIActive &&
      answers.IDProofingRequired === true &&
      answers.TrustedAgentAgreement === false
    ) {
      SetMsg(
        "Registration API is not allowed without a Trusted Agent Agreement if ID Proofing is required."
      );
      SetErrMsg(true);
      return;
    }
    if (answers.DirectTrust && answers.IDProofingRequired == false) {
      SetMsg("ID Proofing is required for DirectTrust.");
      SetErrMsg(true);
      return;
    }
    if (answers.IDProofingRequired === false && answers.TrustedAgentAgreement) {
      SetMsg("Trusted Agent Agreement is not allowed without ID Proofing.");
      SetErrMsg(true);
      return;
    }
    if (answers.RegistrationAPIActive && !answers.ApplicationAccessSESConnect) {
      SetMsg("Registration API  is not allowed without SESConnect license.");
      SetErrMsg(true);
      return;
    }
    answers.BillingAddress.Phone =
      answers.BillingAddress.Phone.replace(/[^0-9]/g, "").substring(0, 10) +
      answers.BillingAddress.PhoneExt;
    answers.BillingAddress.Fax =
      answers.BillingAddress.Fax.replace(/[^0-9]/g, "").substring(0, 10) +
          answers.BillingAddress.FaxExt;
      if (validatePhoneNumber(answers.BillingAddress.Phone)) {
          document.getElementById("Phone").scrollIntoView();
          document.getElementById("Phone").focus();
          return;
      }
      if (validatePhoneNumber(answers.BillingAddress.Fax)) {
          document.getElementById("Fax").scrollIntoView();
          document.getElementById("Fax").focus();
          return;
      }
    SetProcessing(true);
    answers.CreatedBy = userRole;
    console.log("Fax number:" + answers.BillingAddress.Fax);
    let call = "/customers/CreateCustomer";
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let o = {
        ...answers,
        id: res.data.data.id,
        VendorId: res.data.data.id,
        Type: "top",
        OrgType: "top",
      };
      setCustomerObj(o);
      await SetSharedObject("orgActionObj", o);
      await SetSharedObject("CustomerPermissionsObj", o);
      await getUsers();
      setCustomerFlag(true);
      SetProcessing(false);
      navigate("/toplevel-org-registration");
    } else if (res.status === "SERVERERROR") {
      let str = "";
      if (res?.data?.VendorName?.length > 0) {
        str = res?.data?.VendorName[0];
      } else {
        str =
          "A system error occurred searching for your results. Please contact support for further assistance.";
      }
      SetMsg(str);
      SetErrMsg(true);
      SetProcessing(false);
    }
  };
  const getUsers = async () => {
    SetProcessing(true);
    SetErrMsg(false);
    let call = "/users/GetUsersValues";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      console.log(res.data.data.vendors);
      await SetSharedObject("vendorsObj", res.data.data.vendors);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let str =
        "A system error occurred searching for your results. Please contact support for further assistance.";
      SetMsg(str);
      SetErrMsg(true);
      SetProcessing(false);
    }
  };
  return (
    <div className="RegFormCustomer">
      <form className="needs-validation" noValidate>
        <div class="form-container">
          {/*Customer Name*/}
          <div className="w-lg2 spacer-inline v-top">
            <label for="Name">Customer Name</label>
            <input
              className="form-control"
              name="Name"
              id="Name"
              value={answers.Name}
              onChange={(el) => setAnswer("Name", el.target.value)}
            />
            {!answers.Name && frmSubmFlag ? (
              <div className="alert alert-danger">
                Customer name is required.
              </div>
            ) : null}
          </div>
          {/*Domains*/}
          <div className="w-lg9 spacer-inline sp-margin17 v-top">
            <label for="BaseDomainId">Domain</label>
            <select
              className="form-control"
              name="BaseDomainId"
              id="BaseDomainId"
              value={answers.BaseDomainId}
              onChange={(el) => setAnswer("BaseDomainId", el.target.value)}
            >
              <option value="">Select</option>
              {domainObj?.map((el) => (
                <option key={el.value} value={el.value}>
                  {el.text}
                </option>
              ))}
            </select>
            {!answers.BaseDomainId && frmSubmFlag ? (
              <div className="alert alert-danger">
                Domain selection is required.
              </div>
            ) : null}
          </div>

          {/*Contact Information*/}
          <div className="field-wrapper title-divider">Contact Information</div>
          {/*Address 1*/}
          <div className="field-wrapper field-box2">
            <label for="AddressOne">Address 1</label>
            <input
              className="form-control"
              name="Street1"
              id="Street1"
              value={answers.BillingAddress.Street1}
              onChange={(el) => setAnswer("Street1", el.target.value, true)}
            />
            {!answers.BillingAddress.Street1 && frmSubmFlag ? (
              <div className="alert alert-danger">Address is required.</div>
            ) : null}
          </div>
          {/*Address 2*/}
          <div className="field-wrapper field-box3">
            <label for="Street2">Address 2</label>
            <input
              className="form-control"
              name="Street2"
              placeholder="Optional"
              value={answers.BillingAddress.Street2}
              onChange={(el) => setAnswer("Street2", el.target.value, true)}
            />
          </div>
          <div className="field-wrapper field-box2 v-top">
            <label for="city">City</label>
            <input
              className="form-control"
              name="City"
              id="City"
              value={answers.BillingAddress.City}
              onChange={(el) => setAnswer("City", el.target.value, true)}
            />
            {!answers.BillingAddress.City && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger">City is required.</div>
              </div>
            ) : null}
          </div>
          <div className="field-wrapper spacer-inline">
            {/*State*/}
            <div className="spacer-inline field-ext spacer-margin5">
              <label for="State">State</label>
              <select
                className="form-control"
                name="State"
                id="State"
                value={answers.BillingAddress.State}
                onChange={(el) => setAnswer("State", el.target.value, true)}
              >
                <option value="">Select</option>
                {stateCodeArray.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </select>
               {!answers.BillingAddress.State && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger"> State is required. </div>
              </div>
            ) : null}
            </div>
            {/*Zip Code*/}
            <div className="spacer-inline field-ext">
              <label for="ZIP">Zip</label>
              <input
                className="form-control"
                id="ZIP"
                name="ZIP"
                value={answers.BillingAddress.ZIP}
                onChange={(el) => setAnswer("ZIP", el.target.value, true)}
              />
               {!answers.BillingAddress.ZIP && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger">Zip is required.</div>
              </div>
            ) : null}
            </div>
           
          </div>
          {/*Phone*/}
          <div className="field-wrapper ">
            <div className="field-box2">
              <label for="Phone">Phone</label>
              <input
                className="form-control"
                id="Phone"
                name="Phone"
                value={formatPhoneNumber(answers.BillingAddress.Phone)}
                onChange={(el) => setAnswer("Phone", el.target.value, true)}
              />
               {!answers.BillingAddress.Phone && frmSubmFlag ? (
              <div className="alert alert-danger">
                Phone number is required.
              </div>
            ) : null}
                          {(answers.BillingAddress.Phone.replace(/[^0-9]/g, "").substring(0, 10).length < 10 && frmSubmFlag) && (answers.BillingAddress.Phone.replace(/[^0-9]/g, "").substring(0, 10).length > 0 && frmSubmFlag) ? (
              <div className="alert alert-danger">
                Invalid Phone Number.
              </div>
            ) : null}
            </div>
            <div className="spacer-inline field-ext v-top">
              <label for="PhoneExt">Ext</label>
              <input
                className="form-control"
                name="PhoneExt"
                type="number"
                value={answers.BillingAddress.PhoneExt}
                onChange={(el) => {
                  let vl = el.target.value;
                  if (vl.length < 7) {
                    setAnswer("PhoneExt", el.target.value, true);
                  }
                }}
              />
              
            </div>
          </div>
          {/*Fax*/}
          <div className="field-wrapper">
            <div className="field-box2">
              <label for="Fax">Fax</label>
              <input
                className="form-control"
                name="Fax"
                placeholder="Optional"
                value={formatPhoneNumber(answers.BillingAddress.Fax)}
                onChange={(el) => setAnswer("Fax", el.target.value, true)}
              />
            {(answers.BillingAddress.Fax.replace(/[^0-9]/g, "").substring(0, 10).length < 10 && frmSubmFlag) && (answers.BillingAddress.Fax.replace(/[^0-9]/g, "").substring(0, 10).length > 0 && frmSubmFlag) ? (
              <div className="alert alert-danger">Invalid Fax Number.</div>
            ) : null}
            </div>
            <div className="spacer-inline field-ext v-top">
              <label for="FaxExt">Ext</label>
              <input
                className="form-control"
                type="number"
                name="FaxExt"
                value={answers.BillingAddress.FaxExt}
                onChange={(el) => {
                  let vl = el.target.value;
                  if (vl.length < 7) {
                    setAnswer("FaxExt", el.target.value, true);
                  }
                }}
              />
            </div>
          </div>

          {/*Verification*/}
          <div class="field-wrapper title-divider">Verifications</div>
          <div class="field-wrapper">
            <section>
              <input
                type="checkbox"
                className="spacer-margin5"
                name="DirectTrust"
                id="DirectTrust"
                checked={answers.DirectTrust}
                value={answers.DirectTrust}
                onClick={(el) => setAnswer("DirectTrust", el.target.checked)}
              />
              <label>DirectTrust</label>
            </section>
            <section>
              <input
                type="checkbox"
                className="spacer-margin5"
                name="IDProofingRequired"
                id="IDProofingRequired"
                checked={answers.IDProofingRequired}
                value={answers.IDProofingRequired}
                onClick={(el) =>
                  setAnswer("IDProofingRequired", el.target.checked)
                }
              />
              <label>ID Proofing Required </label>
            </section>
            <section>
              <input
                type="checkbox"
                className="spacer-margin5"
                name="TrustedAgentAgreement"
                id="TrustedAgentAgreement"
                checked={answers.TrustedAgentAgreement}
                value={answers.TrustedAgentAgreement}
                onClick={(el) =>
                  setAnswer("TrustedAgentAgreement", el.target.checked)
                }
              />
              <label className="spacer-margin8">Trusted Agent </label>
            </section>
          </div>

          {/*Permissions*/}
          <div class="field-wrapper title-divider">Permissions</div>
          <div class="field-wrapper permissions">
            <section className="text-reg spacer-margin7">
              When selecting the permissions below at the customer level, it
              will be available at the organization level to enable or disable
              for each organization. Deselecting will not be available.
            </section>
            <ul>
              <li>
                <input
                  class="form-control spacer-margin5"
                  type="checkbox"
                  name="ApplicationAccessSESConnect"
                  id="ApplicationAccessSESConnect"
                  checked={answers.ApplicationAccessSESConnect}
                  value={answers.ApplicationAccessSESConnect}
                  onClick={(el) =>
                    setAnswer("ApplicationAccessSESConnect", el.target.checked)
                  }
                />
                <label className="v-top">SESConnect</label>
              </li>
              {/*<li>*/}
              {/*  <input*/}
              {/*    type="checkbox"*/}
              {/*    className="spacer-margin5"*/}
              {/*    name="TrustedAgentAgreement"*/}
              {/*    id="TrustedAgentAgreement"*/}
              {/*    checked={answers.TrustedAgentAgreement}*/}
              {/*    value={answers.TrustedAgentAgreement}*/}
              {/*    onClick={(el) =>*/}
              {/*      setAnswer("TrustedAgentAgreement", el.target.checked)*/}
              {/*    }*/}
              {/*  />*/}
              {/*  <label className="spacer-margin8">Trusted Agent </label>*/}
              {/*</li>*/}
              <li>
                <input
                  type="checkbox"
                  className="spacer-margin5"
                  name="RegistrationAPIActive"
                  id="RegistrationAPIActive"
                  checked={answers.RegistrationAPIActive}
                  value={answers.RegistrationAPIActive}
                  onClick={(el) =>
                    setAnswer("RegistrationAPIActive", el.target.checked)
                  }
                />
                <label className="spacer-margin8">Registration API</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  className="spacer-margin5"
                  name="IsDirectorySharing"
                  id="IsDirectorySharing"
                  checked={answers.IsDirectorySharing}
                  value={answers.IsDirectorySharing}
                  onClick={(el) =>
                    setAnswer("IsDirectorySharing", el.target.checked)
                  }
                />
                <label className="spacer-margin8">
                  Share Directory Listing
                </label>
              </li>
              <li>
                <input
                  type="checkbox"
                  className="spacer-margin5"
                  name="DirectRoute"
                  id="DirectRoute"
                  checked={answers.DirectRoute}
                  value={answers.DirectRoute}
                  onClick={(el) => setAnswer("DirectRoute", el.target.checked)}
                  disabled={answers.EmailForwardingTypeBox}
                />
                <label className="spacer-margin8">DirectRoute</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  className="spacer-margin5"
                  name="EmailForwardingTypeBox"
                  id="EmailForwardingTypeBox"
                  checked={answers.EmailForwardingTypeBox}
                  value={answers.EmailForwardingTypeBox}
                  disabled={answers.DirectRoute}
                  onClick={(el) =>
                    setAnswer("EmailForwardingTypeBox", el.target.checked)
                  }
                />
                <label className="spacer-margin8">Advanced DirectRoute</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  className="spacer-margin5"
                  name="ApplicationAccessENS"
                  id="ApplicationAccessENS"
                  checked={answers.ApplicationAccessENS}
                  value={answers.ApplicationAccessENS}
                  onClick={(el) =>
                    setAnswer("ApplicationAccessENS", el.target.checked)
                  }
                />
                <label className="spacer-margin8">Notify</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  className="spacer-margin5"
                  name="ApplicationAccessXDR"
                  id="ApplicationAccessXDR"
                  checked={answers.ApplicationAccessXDR}
                  value={answers.ApplicationAccessXDR}
                  onClick={(el) =>
                    setAnswer("ApplicationAccessXDR", el.target.checked)
                  }
                />
                <label className="spacer-margin8">XDR-Access</label>
              </li>
              <li>
                <input
                  type="checkbox"
                  className="spacer-margin5"
                  name="TwoFactorAuth"
                  id="TwoFactorAuth"
                  checked={answers.TwoFactorAuth}
                  value={answers.TwoFactorAuth}
                  onClick={(el) =>
                    setAnswer("TwoFactorAuth", el.target.checked)
                  }
                />
                <label className="spacer-margin8">
                  Two Factor Authentication
                </label>
              </li>
            </ul>
            {errMsg ? (
              <div className="alert alert-danger" role="alert">
                {msg}
              </div>
            ) : null}
          </div>

          {/*Registration Action*/}
          <div class="button-register-container text-size4">
            <button type="button" class="btn btn-success" onClick={updateUser}>
              Register
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary spacer-margin9 spacer-inline"
              to="/Customers"
              onClick={(el) => {
                ResetData();
                navigate("/Customers");
              }}
            >
              Cancel
            </button>

            {processing ? <div className="loading"></div> : null}
          </div>
        </div>
      </form>
    </div>
  );
};

export default RegFormCustomer;
